import React from "react";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import { CheckedBuildingsData } from "core/queries/GetBuildings";

interface BuildingFilterGroupItemProps {
  building: CheckedBuildingsData;
  onClick?(): void;
}

export const BuildingFilterGroupItem = ({
  building,
  onClick,
}: BuildingFilterGroupItemProps) => {
  const { internalRef, isChecked } = building;

  return (
    <CheckboxDropdownItem checked={isChecked} onClick={onClick}>
      {internalRef}
    </CheckboxDropdownItem>
  );
};
